import { render, staticRenderFns } from "./PLYPreview.vue?vue&type=template&id=3a9c6bf9&scoped=true&"
import script from "./PLYPreview.vue?vue&type=script&lang=js&"
export * from "./PLYPreview.vue?vue&type=script&lang=js&"
import style0 from "./PLYPreview.vue?vue&type=style&index=0&id=3a9c6bf9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c6bf9",
  null
  
)

export default component.exports